import { Route, Redirect } from 'react-router-dom'
import { IonApp, IonRouterOutlet, setupIonicReact } from '@ionic/react'
import { IonReactRouter } from '@ionic/react-router'

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css'

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css'
import '@ionic/react/css/structure.css'
import '@ionic/react/css/typography.css'

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css'
import '@ionic/react/css/float-elements.css'
import '@ionic/react/css/text-alignment.css'
import '@ionic/react/css/text-transformation.css'
import '@ionic/react/css/flex-utils.css'
import '@ionic/react/css/display.css'

/* Theme variables */
import './theme/variables.css'

import it from 'date-fns/locale/it'
import { setDefaultOptions } from 'date-fns'
import React from 'react'
import { PrivateGuard, ProfileMenu } from 'components'
import { ProvideAuth } from 'components/provide-auth/provide-auth.component'
import Home from 'pages/home/home.page'
import About from 'pages/about/about.page'
import Login from 'pages/login/login.page'
import Residences from 'pages/residences/residences.page'
import Residence from 'pages/residence/residence.page'
import BookingConfirm from 'pages/booking-confirm/booking-confirm.page'
import BookingSuccess from 'pages/booking-success/booking-success.page'
import Search from 'pages/search/search.page'
import ErrorPage from 'pages/error/error.page'
import Registration from 'pages/registration/registration.page'
import RegistrationSuccess from 'pages/registration-success/registration-success.page'
import ModifyProfile from 'pages/modify-profile/modify-profile.page'
import UpdatePw from 'pages/update-pw/update-pw.page'
import ResetPw from 'pages/reset-pw/reset-pw.page'
import Spid from 'pages/spid/spid.page'
import BookingHistory from 'pages/booking-history/booking-history.page'
import CompleteRegistration from 'pages/complete-registration/complete-registration'
import CompleteRegGuard from 'components/private-guard/complete-reg-guard.component'

setupIonicReact({
  rippleEffect: false,
  mode: 'md',
})

setDefaultOptions({ locale: it })

const App: React.FC = () => {
  return (
    <ProvideAuth>
      <IonApp>
        <IonReactRouter>
          <IonRouterOutlet id="main-content-id">
            <Route exact path={'/'}>
              <CompleteRegGuard>
                <Home />
              </CompleteRegGuard>
            </Route>
            <Route exact path={'/about'}>
              <CompleteRegGuard>
                <About />
              </CompleteRegGuard>
            </Route>
            <Route exact path={'/login'}>
              <CompleteRegGuard>
                <Login />
              </CompleteRegGuard>
            </Route>
            <Route exact path={'/residences'}>
              <CompleteRegGuard>
                <Residences />
              </CompleteRegGuard>
            </Route>
            <Route exact path={'/residence/:residenceId'}>
              <CompleteRegGuard>
                <Residence />
              </CompleteRegGuard>
            </Route>
            <Route exact path={'/booking-confirm/:uuidBooking'}>
              <CompleteRegGuard>
                <PrivateGuard>
                  <BookingConfirm />
                </PrivateGuard>
              </CompleteRegGuard>
            </Route>
            <Route exact path={'/booking-success/:uuidBooking'}>
              <CompleteRegGuard>
                <PrivateGuard>
                  <BookingSuccess />
                </PrivateGuard>
              </CompleteRegGuard>
            </Route>
            <Route exact path={'/search'}>
              <CompleteRegGuard>
                <Search />
              </CompleteRegGuard>
            </Route>
            <Route exact path={'/error'}>
              <ErrorPage />
            </Route>
            <Route exact path={'/registration'}>
              {/* TODO inserire controllo sul fatto che l'utente non sia loggato*/}
              <CompleteRegGuard>
                <Registration />
              </CompleteRegGuard>
            </Route>
            <Route exact path={'/registration-success'}>
              <CompleteRegGuard>
                <RegistrationSuccess />
              </CompleteRegGuard>
            </Route>
            <Route exact path={'/complete-reg'}>
              <CompleteRegistration />
            </Route>
            <Route exact path={'/modify-profile'}>
              <CompleteRegGuard>
                <PrivateGuard>
                  <ModifyProfile />
                </PrivateGuard>
              </CompleteRegGuard>
            </Route>
            <Route exact path={'/booking-history'}>
              <CompleteRegGuard>
                <PrivateGuard>
                  <BookingHistory />
                </PrivateGuard>
              </CompleteRegGuard>
            </Route>
            <Route exact path={'/update-pw'}>
              <CompleteRegGuard>
                <PrivateGuard>
                  <UpdatePw />
                </PrivateGuard>
              </CompleteRegGuard>
            </Route>
            <Route exact path={'/reset-pw'}>
              <CompleteRegGuard>
                <ResetPw />
              </CompleteRegGuard>
            </Route>
            <Route exact path={'/spid'}>
              <CompleteRegGuard>
                <Spid />
              </CompleteRegGuard>
            </Route>

            <Redirect to="/" />
          </IonRouterOutlet>
          <ProfileMenu />
        </IonReactRouter>
      </IonApp>
    </ProvideAuth>
  )
}

export default App
